import { OperatorFunction, Observable } from 'rxjs';
import { Event } from '@/app/event-stream';
import { map, concatAll, groupBy, mergeAll } from 'rxjs/operators';
import { windowByComparator } from './window-by-comparator-operator';

export interface Mapper {
  key: string;
  mapper: (input: Observable<Event>) => Observable<Event>;
}

export function filterByTypeOperator(mappers: Mapper[]): OperatorFunction<Event, Event> {

  return (input$) => input$.pipe(
    windowByComparator(compareEventType),
    map((x) => x.pipe(
      groupBy((y) => y.name),
      map((group$) => {

        const mapper = mappers.find((y) => y.key === group$.key);
        if (!mapper) { return group$; }

        const mapped = mapper.mapper(group$);
        return mapped;
      }),
      mergeAll()
    )),
    concatAll()
  );

  function compareEventType(event1: Event, event2: Event) {
    return event1.name === event2.name;
  }
}
